import React, { useState }   from 'react'
import logo from './../assets/logo.svg';
import { Link, useNavigate } from 'react-router-dom';
import BadgeNotificationBar from '../components/badges/BadgeNotificationBar';
import { Button } from 'primereact/button'
import { useContext } from 'react';
import DataContext from '../context/DataContext';
import { Menubar } from 'primereact/menubar';
import SocketNotifications from '../components/notificationActions/socketNotifications';
import DrawerButton from '../components/buttonActions/DrawerButton';
import { useMediaQuery } from 'react-responsive';
import { useTranslation } from 'react-i18next';




const Header = () => {

  const {
    notifications, setNotifications, isUserAuntheticated, setIsUserAuntheticated, auntheticatedUser, setAuntheticatedUser
  } = useContext(DataContext);
  const { t } = useTranslation();
  let loggedinUser = auntheticatedUser ? `${auntheticatedUser.firstname + " " + auntheticatedUser.lastname}` : "System User"
  const lhrcinitiated =  (auntheticatedUser?.role === "Admin" || auntheticatedUser?.role === "Operator" || auntheticatedUser?.role === "LHRCstaff") ? true:false
  const navigate = useNavigate();
  
  const isMobile = useMediaQuery({ query: '(max-width: 969px)' })




 
    const UserProfileMenu = [
      {
          label: `${loggedinUser}`,
          icon: 'pi pi-fw pi-user',
          items: [
              {
                  label: 'Profile',
                  icon: 'pi pi-fw pi-users',
                  command: () => { navigate("/userprofile"); },
                  
              },

              {
                  label: "logout",
                  icon: 'pi pi-fw pi-power-off',
                command: () => { setIsUserAuntheticated(false); setAuntheticatedUser(null); navigate("/"); },
              },
              {
                  separator: true
              },
          ]
        },
  ];


  
  return (

    <header className='Header'>
      <div className={isMobile ?  'block h-4rem flex justify-content-start align-items-center ml-3':'hidden'}>
        <DrawerButton  />
      </div>
      <div className={isMobile ? 'hidden':'nameandlogo flex'} style={{ cursor: 'pointer' }} onClick={() => navigate("/")}>
        <div className='logo'
                 
        ><img src={logo} alt="logo" /></div>
        <div className='appname'>HAKIKIGANJANI</div>
      </div>

      
      <div className='plusandothers'>

        <Button
          label={t('Add')}
          icon="pi pi-plus"
          className="p-2 px-3 HeaderIconAddIncident"
          outlined
          onClick={() => navigate("/newincident")}
        />
           
        {lhrcinitiated && <Link to="/notifications" className='linkHeaderIconNotification'> {<BadgeNotificationBar eventCount={notifications?.totalUnprocessed || 0} />} </Link>}
        {lhrcinitiated && <SocketNotifications />}
       
      </div>
      

      <div className='nameandprofile'>
        <Menubar model={UserProfileMenu} className='p-1'/>
      </div>

      
    </header>
  )
}

export default Header